// ProjectCategoryTable.js

const ProjectCategoryTable = ({ assessments, criteria }) => {
  // Создаем маппинг названий критериев -> массив item с score = 0
  const criteriaMap = {};
  // Инициализируем маппинг для каждого критерия
  criteria.forEach(criterion => {
    if (criterion.name) {
      criteriaMap[criterion.name] = [];
    }
  });
  // Собираем все item с score = 0 по соответствующим критериям
  assessments.forEach(assessment => {
    if (assessment.items && Array.isArray(assessment.items)) {
      assessment.items.forEach(item => {
        if (item.score === 0) {
          // Находим критерий по item_id
          const criterion = criteria.find(c => c.id === item.criteria_id);
          if (criterion && criterion.name) {
            criteriaMap[criterion.name].push(item);
          }
        }
      });
    }
  });
  // Преобразуем маппинг в массив для таблицы
  const data = Object.entries(criteriaMap).map(([name, items]) => ({
    category: name,
    count: items.length,
    items: items // сохраняем items для возможного дальнейшего использования
  }))
  // Сортируем по количеству ошибок (по убыванию)
  data.sort((a, b) => b.count - a.count);
  return (
    <div className="table-wrapper flex-4">
      <h3>Статистика по критериям оценки</h3>
      <table className="stats-table" style={{borderCollapse: 'collapse', width: '100%'}}>
        <thead>
        <tr>
          <th>Критерии</th>
          <th>Количество ошибок</th>
          <th>% ошибок</th>
        </tr>
        </thead>
        <tbody>
        {data.map((item) => (
            <tr key={item.category}>
              <td>{item.category}</td>
              <td>{item.count}</td>
              <td
                  style={{
                    backgroundColor: data.length > 0
                        ? (() => {
                          const maxCount = Math.max(...data.map(item => item.count));
                          const totalCount = data.reduce((sum, i) => sum + i.count, 0);
                          const percentage = (item.count / totalCount) * 100;
                          const maxPercentage = (maxCount / totalCount) * 100;

                          // Нормализуем значение от 0 до 100% относительно максимального значения
                          const normalizedPercentage = maxPercentage > 0 ? (percentage / maxPercentage) : 0;

                          // Интерполируем цвет от белого к #F8696B
                          const r = Math.round(255 * (1 - normalizedPercentage) + 248 * normalizedPercentage);
                          const g = Math.round(255 * (1 - normalizedPercentage) + 105 * normalizedPercentage);
                          const b = Math.round(255 * (1 - normalizedPercentage) + 107 * normalizedPercentage);

                          return `rgb(${r}, ${g}, ${b})`;
                        })()
                        : 'white',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    padding: '8px',
                    border: '1px solid #ddd'
                  }}
              >
                {data.length > 0 ? ((item.count / data.reduce((sum, i) => sum + i.count, 0)) * 100).toFixed(1) : '0.0'}%
              </td>
            </tr>
        ))}
        {data.length === 0 && (
            <tr>
              <td colSpan="3" style={{textAlign: 'center'}}>Нет данных для отображения</td>
            </tr>
        )}

        </tbody>
        <tfoot>
          <tr>
            <td>Grand Total</td>
            <td>{data.reduce((sum, stat) => sum + stat.count, 0)}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default ProjectCategoryTable;